<div class="routeButton">
    <button class="example-icon cursor-pointer" mat-raised-button color="primary" [ngClass]="params.class" aria-hidden="false" (click)="onClick($event)">{{params.text |transloco}}</button>
</div>
